module["exports"] = [
  "Aguascalientes",
  "Apodaca",
  "Buenavista",
  "Campeche",
  "Cancún",
  "Cárdenas",
  "Celaya",
  "Chalco",
  "Chetumal",
  "Chicoloapan",
  "Chignahuapan",
  "Chihuahua",
  "Chilpancingo",
  "Chimalhuacán",
  "Ciudad Acuña",
  "Ciudad de México",
  "Ciudad del Carmen",
  "Ciudad López Mateos",
  "Ciudad Madero",
  "Ciudad Obregón",
  "Ciudad Valles",
  "Ciudad Victoria",
  "Coatzacoalcos",
  "Colima-Villa de Álvarez",
  "Comitán de Dominguez",
  "Córdoba",
  "Cuautitlán Izcalli",
  "Cuautla",
  "Cuernavaca",
  "Culiacán",
  "Delicias",
  "Durango",
  "Ensenada",
  "Fresnillo",
  "General Escobedo",
  "Gómez Palacio",
  "Guadalajara",
  "Guadalupe",
  "Guanajuato",
  "Guaymas",
  "Hermosillo",
  "Hidalgo del Parral",
  "Iguala",
  "Irapuato",
  "Ixtapaluca",
  "Jiutepec",
  "Juárez",
  "La Laguna",
  "La Paz",
  "La Piedad-Pénjamo",
  "León",
  "Los Cabos",
  "Los Mochis",
  "Manzanillo",
  "Matamoros",
  "Mazatlán",
  "Mérida",
  "Mexicali",
  "Minatitlán",
  "Miramar",
  "Monclova",
  "Monclova-Frontera",
  "Monterrey",
  "Morelia",
  "Naucalpan de Juárez",
  "Navojoa",
  "Nezahualcóyotl",
  "Nogales",
  "Nuevo Laredo",
  "Oaxaca",
  "Ocotlán",
  "Ojo de agua",
  "Orizaba",
  "Pachuca",
  "Piedras Negras",
  "Poza Rica",
  "Puebla",
  "Puerto Vallarta",
  "Querétaro",
  "Reynosa-Río Bravo",
  "Rioverde-Ciudad Fernández",
  "Salamanca",
  "Saltillo",
  "San Cristobal de las Casas",
  "San Francisco Coacalco",
  "San Francisco del Rincón",
  "San Juan Bautista Tuxtepec",
  "San Juan del Río",
  "San Luis Potosí-Soledad",
  "San Luis Río Colorado",
  "San Nicolás de los Garza",
  "San Pablo de las Salinas",
  "San Pedro Garza García",
  "Santa Catarina",
  "Soledad de Graciano Sánchez",
  "Tampico-Pánuco",
  "Tapachula",
  "Tecomán",
  "Tehuacán",
  "Tehuacán",
  "Tehuantepec-Salina Cruz",
  "Tepexpan",
  "Tepic",
  "Tetela de Ocampo",
  "Texcoco de Mora",
  "Tijuana",
  "Tlalnepantla",
  "Tlaquepaque",
  "Tlaxcala-Apizaco",
  "Toluca",
  "Tonalá",
  "Torreón",
  "Tula",
  "Tulancingo",
  "Tulancingo de Bravo",
  "Tuxtla Gutiérrez",
  "Uruapan",
  "Uruapan del Progreso",
  "Valle de México",
  "Veracruz",
  "Villa de Álvarez",
  "Villa Nicolás Romero",
  "Villahermosa",
  "Xalapa",
  "Zacatecas-Guadalupe",
  "Zacatlan",
  "Zacatzingo",
  "Zamora-Jacona",
  "Zapopan",
  "Zitacuaro"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/address/city_prefix.js
// module id = 1068
// module chunks = 1